import { PaginationModule } from 'ngx-bootstrap/pagination';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpecialDaysComponent } from './special-days.component';
import { TranslateModule } from '@ngx-translate/core';
import { Ng2TableModule } from 'ng2-table/components/ng-table-module';
import { SharedAdministrationModule } from '../shared-administration/shared-administration.module';
@NgModule({
  imports: [
    CommonModule,
    SharedAdministrationModule,
    TranslateModule,
    PaginationModule,
    Ng2TableModule,
  ],
  declarations: [SpecialDaysComponent]
})
export class SpecialDaysModule { }



// WEBPACK FOOTER //
// ./src/app/administration/special-days/special-days.module.ts